import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipBetbuilderSelectionComponent } from './betslip-betbuilder-selection.component';

@Component({
    selector: 'bs-betslip-betbuilder-selection-error',
    templateUrl: './betslip-betbuilder-selection.component.html',
    styleUrls: ['./betslip-betbuilder-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipBetbuilderSelectionErrorComponent extends BetslipBetbuilderSelectionComponent {
    @HostBinding('class.error') error = true;

    constructor(
        public override sitecore: Sitecore,
        epcotConfig: EpcotConfig,
    ) {
        super(epcotConfig, sitecore);
    }

    override get selectionName(): string {
        return this.sitecore.betBuilder.messages?.MinSelectionBetslipError ?? '';
    }

    override get isRemoveButtonVisible(): boolean {
        return false;
    }
}
